import { render, staticRenderFns } from "./CustomerTabDetails.vue?vue&type=template&id=1e65bed4&scoped=true"
import script from "./CustomerTabDetails.vue?vue&type=script&lang=ts"
export * from "./CustomerTabDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65bed4",
  null
  
)

export default component.exports